import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { IAllOpportunityAPIModel, IFilterItemModel, IFilterGroup, IPillsAPIModel, IPaginationModel } from '../models/IAllOpportunitiesModel';
import { GenericState } from './ISliceInterfaces';
import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS, FILTER_GROUP_NAMES, FILTER_COLUMN_NAME } from '../constants/constants';

export interface IFilterAPIModel {
  column: string,
  type: string,
  value: string | string[]
}

export const initialState = {
    partName: '',
    previousPage: '',
    category: '',
    opportunityStatus: '',
    opportunityId: '',
    onboardingTableau: '',
    records: { status: 'idle' } as GenericState<IAllOpportunityAPIModel>,
    filter: [] as IFilterItemModel[],
    pills: { status: 'idle' } as GenericState<IPillsAPIModel[]>,
    categoryPills: { status: 'idle' } as GenericState<IPillsAPIModel[]>,
    pagination: { itemPerpage: 58000, currentPage: 1 } as IPaginationModel,
    export: {loading: false}
}

/** Get All Opportunities */
export const getallOpportunities = createAsyncThunk('tableau/getallOpportunities', async (arg, thunkAPI) => {
  const store: any = thunkAPI.getState();
  const data = buildFilterRequest(store.tableau.filter, store.tableau.pagination);
  const response = await axios.post<IAllOpportunityAPIModel>(OPPORTUNITIES_API_PATHS.acpOpportunities, data);
  return response.data;
});

export const tableauSlice = createSlice({
  name: 'tableau',
  initialState,
  reducers: {
    setPartName: (state, action) => {
      state.partName = action.payload
    },
    setPreviousPage: (state, action) => {
      state.previousPage = action.payload
    },
    setCategory: (state, action) => {
      state.category = action.payload
    },
    setOpportunityStatus: (state, action) => {
      state.opportunityStatus = action.payload
    },
    setOpportunityId: (state, action) => {
      state.opportunityId = action.payload
    },
    setOnboardingTableau: (state, action) => {
      state.onboardingTableau = action.payload
    },
    addFilter: (state, action) => {
      const data = action.payload;
      let isExisting = false;
      // Check condition to add value in existing filter obj or create filter obj by column name
      const uniqueFilterObj = ([...state.filter] ).map((item) => {
        if (item.groupName == data.groupName) {
          isExisting = true;
          if(item.columnName){
            item.value = data.value;
            item.columnName =data.columnName;
          }else{
            item.value = data.value;
          }
          
        }
        return item;
      });
      if (!isExisting)
        uniqueFilterObj.push(data);
      //Remove empty obj from filter to construct badge 
      const validData = [...uniqueFilterObj || []].filter(el => el.value.length > 0);
      state.filter = validData;
    },
    clearAllFilters: (state, action) => {
      state.filter = [];
    },
    removeMasterSearchFilter: (state, action) => {
      const searchRemoved =([...state.filter] ).filter((item,index)=>FILTER_GROUP_NAMES.SEARCH!==item.groupName)
      state.filter = searchRemoved;
    },
    setPaginationCurrentPage: (state, action) => {
      state.pagination.currentPage = action.payload
    },
    setPaginationItemPerPage: (state, action) => {
      state.pagination.currentPage = action.payload
    },
    setExportStatus: (state,action) => {
      state.export.loading = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addCase(getallOpportunities.pending, (state) => {
      state.records.status = 'loading';
    });
    builder.addCase(getallOpportunities.fulfilled, (state, action) => {
      state.records.status = 'finished';
      state.records.data = action.payload;
    });
    builder.addCase(getallOpportunities.rejected, (state) => {
      state.records.status = 'error';
    });
  }
})

export const {setPartName, setPreviousPage, setCategory, setOpportunityStatus, setOpportunityId, setOnboardingTableau, addFilter, clearAllFilters, setPaginationCurrentPage, setPaginationItemPerPage, setExportStatus,removeMasterSearchFilter} = tableauSlice.actions;

export const getPartName = (state: RootState) => state.tableau.partName

export const getPreviousPage = (state: RootState) => state.tableau.previousPage

export const getCategory = (state: RootState) => state.tableau.category

export const getOpportunityStatus = (state: RootState) => state.tableau.opportunityStatus

export const getOpportunityId = (state: RootState) => state.tableau.opportunityId

export const getOnboardingTableau = (state: RootState) => state.tableau.onboardingTableau

export const getAllOpportunitiesSelector = (state: RootState) => state.tableau.records;

export const getFiltersSelector = (state: RootState) => state.tableau.filter;

export const getPaginationSelector = (state: RootState) => state.tableau.pagination;

export const getExportLoadingStatus = (state:RootState) => state.tableau.export.loading;

export default tableauSlice.reducer

export const buildFilterRequest = (filters: IFilterItemModel[], pagination: IPaginationModel) => {
  let data = { "page": pagination.currentPage>0?pagination.currentPage:1, "rows_per_page": pagination.itemPerpage, "filters": [] as IFilterAPIModel[] }
  let requestFilter: IFilterAPIModel[] = [];
  filters.map((item: IFilterItemModel, index) => {
    const type = item.value.length == 1 ? 'eq' : 'in';
    switch (item.groupName) {
      case FILTER_GROUP_NAMES.SEARCH:
        item.value.map((searchItem,index)=>{
          requestFilter.push({
            "column":  item.columnName?item.columnName[index]:'',
            "type": 'eq',
            "value":  searchItem
          })
        })
        break;
      default:
        requestFilter.push({
          "column": FILTER_COLUMN_NAME[item.groupName as keyof IFilterGroup],
          "type": type,
          "value": item.value.length == 1 ? item.value[0] : item.value
        })
    }

  })
  data.filters = requestFilter;
  return data;
}

